import { CoachSeats } from '../../../payment/interfaces/coachSeats';

export const isCoachSeatsLimitReached = (seats: CoachSeats): boolean =>
  seats.usedSeats >= seats.coachSeats;

export const formatSeatsLimitError = (seats: CoachSeats): string =>
  `${seats.usedSeats}/${seats.coachSeats} places are taken, upgrade plan in GHL`;
